var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 36,
    viewBox: "0 0 24 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3984 0.875H23.4297V24.5C23.4297 26.6719 22.9453 28.5938 21.9766 30.2656C21.0234 31.9219 19.6719 33.2031 17.9219 34.1094C16.1719 35.0156 14.1953 35.4688 11.9922 35.4688C8.38281 35.4688 5.57031 34.5547 3.55469 32.7266C1.53906 30.8828 0.53125 28.2812 0.53125 24.9219H7.60938C7.60938 26.5938 7.96094 27.8281 8.66406 28.625C9.36719 29.4219 10.4766 29.8203 11.9922 29.8203C13.3359 29.8203 14.4062 29.3594 15.2031 28.4375C16 27.5156 16.3984 26.2031 16.3984 24.5V0.875Z",
    fill: "url(#paint0_linear_6_72)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_72",
    x1: 11.9805,
    y1: 0.875,
    x2: 11.9805,
    y2: 35.4688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9AE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ);
export default __webpack_public_path__ + "static/media/J.94be43c6e72f849b3317e2835a3e3cf4.svg";
export { ForwardRef as ReactComponent };